<div [class.hidden]="showDisclaimerBlock"
     class="component-container">
  <div class="heading-container">
    {{ !memberId ? 'My ' : '' }} Progress
  </div>
  <div class="filter-container flex flex-col">
    <div
      class="select-control flex flex-row justify-center items-center xs:px-[5rem] sm:px-[5rem] md:px-[10rem] lg:px-[18.3rem]">
      <div class="label flex flex-row">
        Chart <span class="required-mark">*</span>
      </div>
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['chart']"
        [options]="!memberId ? chartOptionsForOwn : chartOptionsForOther"
        [parentFormGroup]="form"
        class="input dashboard-input w-full"
        controlName="chart"
        placeholder="Select one"
        type="small"
      />
    </div>
    <hr>
    <div
      *ngIf="currentCharInstance"
      class="filter-controls flex xs:flex-col sm:flex-row md:flex-row xs:items-center sm:justify-between md:justify-between">
      <div class="date-control-container flex flex-row justify-center items-center">
        <app-date-picker
          [max]="dateConfig.fromDate.max"
          [min]="dateConfig.fromDate.min"
          [parentFormGroup]="form"
          controlName="fromDate"
          label="From"
          placeholder="Select date"
          type="small"
        />
        <app-date-picker
          [max]="dateConfig.toDate.max"
          [parentFormGroup]="form"
          controlName="toDate"
          label="To"
          placeholder="Select date"
          type="small"
        />
      </div>
      <app-primary-button (handleClick)="handlePrint()"
                          [isLoading]="isPrinting"
                          class="w-[14rem] sm:mt-[2rem] md:mt-[2rem]"
                          type="small">
        <div class="button-content flex flex-row justify-center items-center">
          <app-icon svgIcon="printer"></app-icon>
          Print Chart
        </div>
      </app-primary-button>
    </div>
  </div>
  <div class="chart-container">
    <ng-template #chartContainer></ng-template>
  </div>
</div>

<div [class.hidden]="!showDisclaimerBlock"
     class="disclaimer-block-wrapper">
  <div class="flex flex-row space-x-[1rem]">
    <app-icon svgIcon="exclamation-circle"></app-icon>
    <div class="error-message">
      You or your participants are not part of any group.
    </div>
  </div>
</div>
